import { render, staticRenderFns } from "./createBenefit.vue?vue&type=template&id=76035856&scoped=true&"
import script from "./createBenefit.vue?vue&type=script&lang=js&"
export * from "./createBenefit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76035856",
  null
  
)

export default component.exports